<ion-img [src]='faces[setFace]' class="Oval" (click)='recibeClick($event)' [id]='elID'></ion-img>